import { Injectable } from "@angular/core";
import { MatDialog } from "@angular/material/dialog";
import { DialogLeaveAppComponent } from "@app/common/dialog-leave-app/dialog-leave-app.component";

/**
 * Opens external links in the device's system browser when running inside the
 * Flip It mobile app's WebView (confirming with the user first), or in a new
 * tab as normal when running in a regular browser.
 *
 * Native side (already merged on worktree-external-link-open-in-browser)
 * listens for `window.ReactNativeWebView.postMessage(JSON.stringify({ type:
 * "openExternalUrl", url }))` and calls Linking.openURL.
 */
@Injectable({ providedIn: "root" })
export class ExternalLinkService {
  constructor(private dialog: MatDialog) {}

  isInMobileApp(): boolean {
    return typeof window !== "undefined" && !!(window as any).ReactNativeWebView;
  }

  open(url: string | null | undefined): void {
    if (!url) return;

    if (this.isInMobileApp()) {
      this.dialog
        .open(DialogLeaveAppComponent)
        .afterClosed()
        .subscribe((confirmed) => {
          if (confirmed) this.postToNative(url);
        });
      return;
    }

    window.open(url, "_blank", "noopener");
  }

  /**
   * Opens `url` in the system browser with no confirmation. For a step the user has just chosen
   * (FLIP-524: the iPhone's Stripe checkout), where a "leave the app?" dialog would be a second prompt.
   * Returns false outside the app, so the caller can navigate normally.
   */
  openInSystemBrowser(url: string): boolean {
    if (!url || !this.isInMobileApp()) return false;
    this.postToNative(url);
    return true;
  }

  private postToNative(url: string): void {
    (window as any).ReactNativeWebView.postMessage(
      JSON.stringify({ type: "openExternalUrl", url })
    );
  }
}
